module.exports = __webpack_public_path__ + "static/media/url2qr.97dfd075.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/url2qr.png
// module id = 483
// module chunks = 0